const ADMIN_ROLES = [1, 2]

export default function isAdmin(site) {
  return ADMIN_ROLES.includes(site.userRole)
}
